module.exports = __webpack_public_path__ + "static/media/check-form.abed1fa7.svg";